// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Place-bet success only — Lotus matched toast (#7B9B1E) */
.Toastify__toast.lotus-bet-matched-toast,
.Toastify__toast--success.lotus-bet-matched-toast {
  background: #7b9b1e !important;
  color: #fff !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.3) !important;
  padding: 12px 12px 12px 40px !important;
  min-height: 0 !important;
  max-width: 356px;
  margin: 12px auto;
  font-family: Lato, sans-serif;
}

.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-body,
.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-body {
  margin: 0;
  padding: 0;
  color: #fff;
}

.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-icon,
.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  margin: 0;
  color: #fff;
}

.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-icon svg,
.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-icon svg {
  fill: #fff;
}

.lotus-bet-toast-title {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #fff;
}

.lotus-bet-toast-msg {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #fff;
}

.Toastify__toast.lotus-bet-matched-toast .Toastify__close-button,
.Toastify__toast--success.lotus-bet-matched-toast .Toastify__close-button {
  color: #fff;
  opacity: 0.85;
}

@media (max-width: 1119px) {
  .Toastify__toast.lotus-bet-matched-toast,
  .Toastify__toast--success.lotus-bet-matched-toast {
    width: calc(100% - 32px);
    max-width: none;
    margin: 12px auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/lotus-bet-matched-toast.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,sDAAsD;EACtD,uCAAuC;EACvC,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;EACE;;IAEE,wBAAwB;IACxB,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Place-bet success only — Lotus matched toast (#7B9B1E) */\n.Toastify__toast.lotus-bet-matched-toast,\n.Toastify__toast--success.lotus-bet-matched-toast {\n  background: #7b9b1e !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.3) !important;\n  padding: 12px 12px 12px 40px !important;\n  min-height: 0 !important;\n  max-width: 356px;\n  margin: 12px auto;\n  font-family: Lato, sans-serif;\n}\n\n.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-body,\n.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-body {\n  margin: 0;\n  padding: 0;\n  color: #fff;\n}\n\n.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-icon,\n.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  margin: 0;\n  color: #fff;\n}\n\n.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-icon svg,\n.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-icon svg {\n  fill: #fff;\n}\n\n.lotus-bet-toast-title {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  color: #fff;\n}\n\n.lotus-bet-toast-msg {\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #fff;\n}\n\n.Toastify__toast.lotus-bet-matched-toast .Toastify__close-button,\n.Toastify__toast--success.lotus-bet-matched-toast .Toastify__close-button {\n  color: #fff;\n  opacity: 0.85;\n}\n\n@media (max-width: 1119px) {\n  .Toastify__toast.lotus-bet-matched-toast,\n  .Toastify__toast--success.lotus-bet-matched-toast {\n    width: calc(100% - 32px);\n    max-width: none;\n    margin: 12px auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
